import { MarketName } from 'lib/global';
import {
    atde,
    aten,
    been,
    befr,
    benl,
    caen,
    cafr,
    chde,
    chen,
    chfr,
    chit,
    czcs,
    czen,
    dede,
    deen,
    dkda,
    envDefaults,
    esca,
    esen,
    eses,
    eseu,
    esgl,
    fien,
    fifi,
    fisv,
    frfr,
    gben,
    hrhr,
    huhu,
    ieen,
    inen,
    itit,
    jpen,
    jpja,
    kren,
    krko,
    nlen,
    nlnl,
    noen,
    nono,
    plpl,
    pten,
    ptpt,
    roro,
    rssr,
    seen,
    sesv,
    sisl,
    sksk,
    usen,
    uses,
} from '../../environments';
import { SettingsObject } from '.';

// Adding default layer to the market settingObject since this is how ES6 modules handle default exports
const markets: Record<string, { default: Partial<SettingsObject> }> = {
    atde,
    aten,
    been,
    befr,
    benl,
    caen,
    cafr,
    chde,
    chen,
    chfr,
    chit,
    czcs,
    czen,
    dede,
    deen,
    dkda,
    esca,
    esen,
    eses,
    eseu,
    esgl,
    fien,
    fifi,
    fisv,
    frfr,
    gben,
    hrhr,
    huhu,
    ieen,
    inen,
    itit,
    jpen,
    jpja,
    kren,
    krko,
    nlen,
    nlnl,
    noen,
    nono,
    plpl,
    pten,
    ptpt,
    roro,
    rssr,
    seen,
    sesv,
    sksk,
    sisl,
    usen,
    uses,
};

export const getFiles = (market: MarketName) => {
    const defaults = envDefaults(market);
    if (market in markets) {
        return {
            ...defaults,
            ...markets[market].default,
        } as SettingsObject;
    }
    return defaults as SettingsObject;
};
